import * as yup from 'yup';
import { RadioGroupOption } from '../api/clients';

export interface ICommonValidator {
  label: string,
  required?: boolean,
  step: number,
}

interface INullableStringValidator extends ICommonValidator {
  maxLength?: number
}
interface IRequiredIfDependentNullStringValidator extends INullableStringValidator {
  dependent: string,
}
const nullableString = ({ label, step, required, maxLength }: INullableStringValidator) => {
  const validator = yup.string()
    .nullable()
    .label(label)
    .meta({ step })
    .max(maxLength ?? Infinity);

  if (required) return validator.required();
  return validator;
};

const requiredIfDependentNullString = ({ label, step, required, maxLength, dependent }: IRequiredIfDependentNullStringValidator) => {
  const validator = nullableString({ label, step });

  return validator
    .when(dependent, {
      is: (field: string) => field === null,
      then: (schema) => schema.required(),
      otherwise: (schema) => schema.optional(),
    });
};

interface ITimeValidator extends ICommonValidator { message: string }
const time = ({ message, label, step, required }: ITimeValidator) => {
  const validator = yup.string()
    .nullable()
    .matches(/^([01]\d|2[0-3]):?([0-5]\d)$/, { message })
    .label(label)
    .meta({ step });

  return required ? validator.required() : validator.optional();
};

interface ITernaryValidator extends ICommonValidator {
  maxLength?: number
}
const ternary = ({ label, step, required, maxLength }: ITernaryValidator) => {
  const validator = nullableString({ label, step, required, maxLength });

  return validator.oneOf(['Yes', 'No', 'NotApplicable']);
};

interface IRadioGroupOptionValidator extends ICommonValidator {}
const radioGroupOption = ({ label, step, required }: IRadioGroupOptionValidator) => {
  const validator = yup.mixed<RadioGroupOption>()
    .nullable()
    .label(label)
    .meta({ step })
    .oneOf(Object.values(RadioGroupOption));

  return required ? validator.required() : validator;
};

export default {
  nullableString,
  requiredIfDependentNullString,
  time,
  ternary,
  radioGroupOption,
};
